import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import { newQuotationActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-quotation.reducer";
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import QuotationLocationForm from '../new-quotation/quotation-exhibit-a/quotation-location-form.component';
import QuotationSubscriptionForm from '../new-quotation/quotation-exhibit-a/quotation-subscription-form.component';
import QuotationBusinessForm from '../new-quotation/quotation-exhibit-a/quotation-business-form.component';
import Icons from '../../../../../icon';
import Translation from '../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { Milestone } from '../../../../../common/milestone/milestone.component';

class NewQuotationForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLocationForm: true,
            isSubscriptionForm: false,
            isBusinessForm: false,
            activeIndex:0,
            milestones:[
                "location",
                "capital_pos",
                "business_justification"
            ],
        }
    }

    componentWillUnmount() {
        this.props.resetQuotationForm();
        this.props.resetRequestData();
    }

    nextAction = () => {

        const { isLocationForm, isSubscriptionForm } = this.state;
        const { disableROBCheckbox } = this.props;

        if (isSubscriptionForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: false,
                isBusinessForm: true,
                activeIndex: 2  
            });
        }
        else if (isLocationForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false,
                activeIndex: 1  
            });

            disableROBCheckbox(true);
        }
        else {
            console.log("Submit")
        }
    }

    prevAction = () => {
        const { isSubscriptionForm, isBusinessForm } = this.state;
        const { disableROBCheckbox } = this.props;       
        if (isBusinessForm) {          
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false,
                activeIndex: 1
            });             
        }
        else if (isSubscriptionForm) {           
            this.setState({
                isLocationForm: true,
                isSubscriptionForm: false,
                isBusinessForm: false,
                activeIndex: 0
            });           
            disableROBCheckbox(false);
        }
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose !== null && modalClose !== undefined) {
            modalClose();
        }
    }

    displayForm = () => {
        const { isLocationForm, isSubscriptionForm, isBusinessForm } = this.state;
        let form;

        if (isLocationForm) {
            form = <QuotationLocationForm onClickCancel={this.onClickCancel} nextAction={this.nextAction} />
        } else if (isSubscriptionForm) {
            form = <QuotationSubscriptionForm disableAutoScroll={this.props.disableAutoScroll} onClickCancel={this.onClickCancel} nextAction={this.nextAction} prevAction={this.prevAction}/>
        } else {
            form = <QuotationBusinessForm onClickCancel={this.onClickCancel} hideRequestModal={this.props.hideRequestModal} prevAction={this.prevAction} modalMessage={this.props.modalMessage}/>
        }

        return (form);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const { isLocationForm, isSubscriptionForm, isBusinessForm } = this.state;
        return (
            <div>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <h6 className="plan-detail-sub-header"><Translation translationKey="order_request_details" /></h6>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <Milestone milestones={this.state.milestones} activeIndex={this.state.activeIndex}/>
                    </Col>
                </Row>
                {this.displayForm()}
            </div>
        );
    }
};
export default connect(
    state => {
        const { createRequest, translation } = state;
        const { wirelessLocationFormA } = state.form;
        return {
            createRequest
            , wirelessLocationFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newQuotationActions
                , createRequestActions),
            dispatch
        )
)(NewQuotationForm);